import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_FUTURE_SAP_MARKETING_CONSENT_REQUIRED = createFcmDetails(
	'future_sap_marketing_consent_required',
	{
		owner: 'Modern Petitioning Pack',
		context: 'Start a Petition GDPR flow',
		description: 'This country feature config prompts the user to provide their marketing consent.',
		import: false,
	},
);
